import { connect } from 'react-redux';
import { useTheme } from '@stripcash/ui-kit/hoc/Theme';
import { AnimatePresence } from 'motion/react';

import { MODAL_TYPES } from 'common/constants/common';
import NewsAlertModal from 'common/components/NewsAlertModal';
import ConfirmationModal from 'common/components/ConfirmationModal';
import ModalsRegistry from 'common/helpers/ModalsRegistry';
import { hideModalAction, UIState } from 'common/reducers/ui';

export const modalsComponents = new ModalsRegistry<MODAL_TYPES>({
  [MODAL_TYPES.CONFIRMATION_MODAL]: ConfirmationModal,
  [MODAL_TYPES.NEWS_ALERT_MODAL]: NewsAlertModal,
});

type ModalsContainerTypes = {
  currentModalName: UIState['currentModalName'];
  currentModalParams: UIState['currentModalParams'];
  onClose: () => void;
};

export const ModalsContainer = ({
  currentModalName,
  currentModalParams = {},
  onClose,
}: ModalsContainerTypes) => {
  const { currentTheme } = useTheme();
  const Modal = modalsComponents.getSpecificModal(
    currentModalName as MODAL_TYPES,
  );

  return (
    <AnimatePresence initial={false}>
      {Modal && (
        <Modal
          onClose={onClose}
          params={{ ...currentModalParams, currentTheme }}
        />
      )}
    </AnimatePresence>
  );
};

const mapStateToProps = (state: { ui: UIState }) => {
  const {
    ui: { currentModalName, currentModalParams },
  } = state;

  return {
    currentModalName,
    currentModalParams,
  };
};

export default connect(mapStateToProps, { onClose: hideModalAction })(
  ModalsContainer,
);
